(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oilcombe-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('oilcombe-gallery')) {
  customElements.define('oilcombe-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-oc-target]');
        if (!button || !this.contains(button)) return;
        const target = document.getElementById(button.dataset.ocTarget);
        if (!target || !this.contains(target)) return;
        this.querySelectorAll('.oc-pdp-media').forEach(media => {
          media.hidden = media !== target;
          if (media.hidden) media.querySelectorAll('video').forEach(video => video.pause());
        });
        this.querySelectorAll('[data-oc-target]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
